<dx-drawer class="thomas-dock-drawer" template="panel" position="right" revealMode="slide"
  [opened]="opened" [openedStateMode]="openedStateMode" [animationDuration]="animationDuration" [shading]="false" [closeOnOutsideClick]="false"
  (onOptionChanged)="onOptionChanged($event)">
  <dx-resizable *dxTemplate="let data of 'panel'" class="thomas-dock-resizable" [class.thomas-dock-fixed]="!canResize" handles="left"
    [width]="width" [minWidth]="minWidth" [maxWidth]="maxWidth" (onInitialized)="onResizableInitialized($event)" (onResizeEnd)="onResizeEnd($event)">
    <div class="thomas-dock" role="complementary" aria-label="Truth Engine AI Assistant" (keydown.escape)="thomas.open = false">
      @if (thomas.docked && thomas.available) {
        <div class="thomas-header">
          <button type="button" class="thomas-header-button" title="New conversation" aria-label="New conversation" (click)="newConversation()">
            <i class="material-icons">refresh</i>
          </button>
          <span class="thomas-header-title">Truth Engine AI Assistant</span>
          <span class="thomas-header-actions">
            @if (!thomas.managingPrompts) {
              <button type="button" class="thomas-header-button" title="Float as a popup" aria-label="Show Thomas as a popup" (click)="thomas.setMode('popup')">
                <i class="material-icons">picture_in_picture_alt</i>
              </button>
            }
            <button type="button" class="thomas-header-button" title="Close" aria-label="Close Thomas" (click)="thomas.open = false">
              <i class="material-icons">close</i>
            </button>
          </span>
        </div>
        <js-thomas-chat></js-thomas-chat>
      }
    </div>
  </dx-resizable>
  <ng-content></ng-content>
</dx-drawer>
